import { GroundTruthEditorShell } from '@/features/GroundTruthHub/GroundTruthEditorShell';
import {
    GroundTruthNotFound,
    groundTruthRouteBoundaries,
} from '@/features/GroundTruthHub/GroundTruthNotFound';
import { RowEditor } from '@/features/GroundTruthHub/RowEditor';
import { isNotFoundError, useGtFileDocs } from '@/features/GroundTruthHub/api';
import { ingestedFileIdAndDocIdParams } from '@/features/GroundTruthHub/routeParams';
import { createFileRoute } from '@tanstack/react-router';

import { LoadingScreen } from '@/components/loading-screen';

/** Exported so it can be unit-tested with plain props; see `sheets.test.tsx`. */
export function RowEditorRoute({
    ingestedFileId,
    docId,
}: {
    ingestedFileId: number;
    docId: number;
}) {
    const { data: docs, isLoading, error } = useGtFileDocs(ingestedFileId);

    if (isLoading) return <LoadingScreen />;

    // The doc must exist and belong to this file; other load errors fall through to the editor's own handling.
    if (
        isNotFoundError(error) ||
        (docs && !docs.some((doc) => doc.id === docId))
    ) {
        return <GroundTruthNotFound what={`Document #${docId}`} />;
    }

    return (
        <GroundTruthEditorShell title={`Line items — doc #${docId}`}>
            <RowEditor docId={docId} />
        </GroundTruthEditorShell>
    );
}

function RowEditorRouteComponent() {
    const { ingestedFileId, docId } = Route.useParams();
    return <RowEditorRoute ingestedFileId={ingestedFileId} docId={docId} />;
}

export const Route = createFileRoute(
    '/ground-truth/$ingestedFileId/$docId/rows',
)({
    ...groundTruthRouteBoundaries,
    component: RowEditorRouteComponent,
    params: ingestedFileIdAndDocIdParams,
});
